import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import $ from "jquery";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import { GetAllTE_OS_NatureOfSupport } from "../../../../Redux/Reducers/ProjectInformationPage/OtherProjectSupport/DropDownForNatutralOfWork";
import AddOtherProjectSupport from "../../../../Services/ProjectInformationPage/OtherProjectSupport/AddOtherProjectSupport";
import UpdateOtherProjectSupport from "../../../../Services/ProjectInformationPage/OtherProjectSupport/UpdateOtherProjectSupport";
import { GetOneOtherProjectSupport } from "../../../../Redux/Reducers/ProjectInformationPage/OtherProjectSupport/indexOne";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import { GetAllTE_TT_TypeOfWork } from "../../../../Redux/Reducers/ProjectInformationPage/ProjectTechnicalTeamMembers/DropDownsProjectTechnicalTeamMembers";
import AddProjectTechnicalTeamMembers from "../../../../Services/ProjectInformationPage/ProjectTechnicalTeamMembers/AddProjectTechnicalTeamMembers";
import UpdateProjectTechnicalTeamMembers from "../../../../Services/ProjectInformationPage/ProjectTechnicalTeamMembers/UpdateProjectTechnicalTeamMembers";
import {
  GetOneProjectTechnicalTeamMembers,
  restValidationProjectTechnical,
  ValidateProjectTechnicalTeamMembers,
} from "../../../../Redux/Reducers/ProjectInformationPage/ProjectTechnicalTeamMembers/indexOne";
import AttachmentASFH from "../../../../Components/AttachmentsAHSF";
import loadConfig from "../../../../Services/apiService";
import axios from "axios";
import Swal from "sweetalert2";

const AddEditProjectTech = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      DropDownTE_TT_TypeOfWork:
        state.DropDownTE_TT_TypeOfWork.DropDownTE_TT_TypeOfWork,
      OneProjectTechnicalTeamMembers:
        state.OneProjectTechnicalTeamMembers.OneProjectTechnicalTeamMembers,
      loadingOneProjectTechnicalTeamMembers:
        state.OneProjectTechnicalTeamMembers
          .loadingOneProjectTechnicalTeamMembers,
      TeamMembersPreviousExperiencePartnerships:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousExperiencePartnerships,
      tE_MAinTeamMembersPreviousExperiencePartnershipsId:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousExperiencePartnerships
          .tE_MAinTeamMembersPreviousExperiencePartnershipsId,
      tE_TeamMembersPreviousExperiencePartnershipsId:
        state.tE_MAinTeamMembersPreviousExperiencePartnershipsId
          ?.tE_TeamMembersPreviousExperiencePartnershipsId,

      ProjectTechnicalTeamMembersValidate:
        state.OneProjectTechnicalTeamMembers
          .ProjectTechnicalTeamMembersValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  // List for Gender options (Male, Female)
  const MaleOrFemale = [
    { KeyText: "ذكر", KeyValue: true },
    { KeyText: "انثى", KeyValue: false },
  ];
  // Initializing state for Project Technical Team Members
  const [ProjectTechList, setProjectTechList] = useState({
    tE_TT_ProjectTechnicalTeamMembersId:
      state.OneProjectTechnicalTeamMembers?.tE_TT_ProjectTechnicalTeamMembersId,
    fourPartName: state.OneProjectTechnicalTeamMembers?.fourPartName,
    gender: state.OneProjectTechnicalTeamMembers?.gender,
    idDocumentAttachment:
      state.OneProjectTechnicalTeamMembers?.idDocumentAttachment,
    cvDocumentAttachment:
      state.OneProjectTechnicalTeamMembers?.cvDocumentAttachment,
    tE_TT_TypeOfWorkId:
      state.OneProjectTechnicalTeamMembers?.tE_TT_TypeOfWorkId,
    tE_TeamMembersPreviousExperiencePartnershipsId:
      state.OneOtherProjectSupport
        ?.tE_TeamMembersPreviousExperiencePartnershipsId,
    tE_MAinTeamMembersPreviousExperiencePartnershipsId:
      state.tE_TeamMembersPreviousExperiencePartnershipsId,
  });
  // State for file attachments (ID Document, CV Document)
  const [IDDocumentAttachment, setIDDocumentAttachment] = useState();
  const [CVDocumentAttachment, setCVDocumentAttachment] = useState();
  const [fileChange, setFileChange] = useState(0);
  const [fileChange2, setFileChange2] = useState(0);
  const [dataJsonObject, SetDataJsonObject] = useState();
  // Function to load configuration data
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson(); // Load config on component mount
  }, []);

  useEffect(() => {
    // Fetch dropdown options for TypeOfWork
    dispatch(GetAllTE_TT_TypeOfWork());
    //console.log(ProjectTechList, "ProjectTechList");
  }, []);

  // const AddProjectTech = async () => {
  //   await AddProjectTechnicalTeamMembers(
  //     ProjectTechList.fourPartName,
  //     ProjectTechList.gender == "true" ? true : false,
  //     ProjectTechList.idDocumentAttachment,
  //     ProjectTechList.cvDocumentAttachment,
  //     ProjectTechList.tE_TT_TypeOfWorkId,
  //     ProjectTechList.tE_TeamMembersPreviousExperiencePartnershipsId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };

  const AddProjectTech = async () => {
    // Function to add a new Project Technical Team Member

    const validationList = await dispatch(
      ValidateProjectTechnicalTeamMembers({
        fourPartName: ProjectTechList.fourPartName,
        gender:
          ProjectTechList.gender === "true"
            ? true
            : ProjectTechList.gender === "false"
            ? false
            : null,
        tE_TT_TypeOfWorkId: ProjectTechList.tE_TT_TypeOfWorkId,
        idDocumentAttachment: ProjectTechList.idDocumentAttachment,
        cvDocumentAttachment: ProjectTechList.cvDocumentAttachment,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");
    // If there are no validation errors, proceed with adding the data
    if (validationList.payload.length === 0) {
      await axios
        .post(
          `${dataJsonObject.domainUrl}/api/TE_TT_ProjectTechnicalTeamMembers/AddTE_TT_ProjectTechnicalTeamMembersData`,
          {
            fourPartName: ProjectTechList.fourPartName,
            gender: ProjectTechList.gender == "true" ? true : false,
            file: IDDocumentAttachment,
            fileName: "IDDocumentAttachment",
            file2: CVDocumentAttachment,
            fileName2: "CVDocumentAttachment",
            IDDocumentAttachment: ProjectTechList.idDocumentAttachment,
            CVDocumentAttachment: ProjectTechList.cvDocumentAttachment,
            tE_TT_TypeOfWorkId: ProjectTechList.tE_TT_TypeOfWorkId,
            tE_TeamMembersPreviousExperiencePartnershipsId:
              ProjectTechList.tE_TeamMembersPreviousExperiencePartnershipsId,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          //console.log(res);
          $(".close-btn").trigger("click"); // Close modal after successful submission

          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم اضافة المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });

          dispatch(setRefreshTable());
        })
        .catch((err) => {
          //console.log(err);
        });
    }
  };
  useEffect(() => {
    dispatch(restValidationProjectTechnical()); // Reset validation state when component mounts
  }, []);
  // Function to update an existing Project Technical Team Member
  const UpdateProjectTech = async () => {
    const validationList = await dispatch(
      ValidateProjectTechnicalTeamMembers({
        fourPartName: ProjectTechList.fourPartName,
        gender:
          ProjectTechList.gender === "true" || ProjectTechList.gender == true
            ? true
            : ProjectTechList.gender === "false" ||
              ProjectTechList.gender == false
            ? false
            : null,
        tE_TT_TypeOfWorkId: ProjectTechList.tE_TT_TypeOfWorkId,
        idDocumentAttachment: ProjectTechList.idDocumentAttachment,
        cvDocumentAttachment: ProjectTechList.cvDocumentAttachment,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");
    // If there are no validation errors, proceed with updating the data

    if (validationList.payload.length === 0) {
      await axios
        .post(
          `${dataJsonObject.domainUrl}/api/TE_TT_ProjectTechnicalTeamMembers/UpdateTETTProjectTechnicalTeamMembersData`,
          {
            tE_TT_ProjectTechnicalTeamMembersId:
              ProjectTechList.tE_TT_ProjectTechnicalTeamMembersId,
            fourPartName: ProjectTechList.fourPartName,
            gender:
              ProjectTechList.gender === "true" ||
              ProjectTechList.gender == true
                ? true
                : ProjectTechList.gender === "false" ||
                  ProjectTechList.gender == false
                ? false
                : null,
            file: fileChange > 0 ? IDDocumentAttachment : null,
            fileName: fileChange > 0 ? "IDDocumentAttachment" : null,
            file2: fileChange2 > 0 ? CVDocumentAttachment : null,
            fileName2: fileChange2 > 0 ? "CVDocumentAttachment" : null,

            IDDocumentAttachment: ProjectTechList.idDocumentAttachment,
            CVDocumentAttachment: ProjectTechList.cvDocumentAttachment,
            tE_TT_TypeOfWorkId: ProjectTechList.tE_TT_TypeOfWorkId,
            tE_TeamMembersPreviousExperiencePartnershipsId:
              ProjectTechList.tE_TeamMembersPreviousExperiencePartnershipsId,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          //console.log(res);
          $(".close-btn").trigger("click");
          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم تعديل المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });
          dispatch(setRefreshTable());
        })
        .catch((err) => {
          //console.log(err);
        });
    }
  };

  // const UpdateProjectTech = async () => {
  //   await UpdateProjectTechnicalTeamMembers(
  //     ProjectTechList.tE_TT_ProjectTechnicalTeamMembersId,
  //     ProjectTechList.fourPartName,
  //     ProjectTechList.gender == "true" ? true : false,
  //     ProjectTechList.idDocumentAttachment,
  //     ProjectTechList.cvDocumentAttachment,
  //     ProjectTechList.tE_TT_TypeOfWorkId,
  //     ProjectTechList.tE_TeamMembersPreviousExperiencePartnershipsId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };
  useEffect(() => {
    // Effect to fetch rojectTechnicalTeamMembers details if available

    if (props != null) {
      dispatch(
        GetOneProjectTechnicalTeamMembers(
          props.tE_TT_ProjectTechnicalTeamMembersId
        )
      );
    }
  }, [props.tE_TT_ProjectTechnicalTeamMembersId]);
  useEffect(() => {
    // Effect to set ProjectTech list based on fetched data or reset

    if (
      !state.loadingOneProjectTechnicalTeamMembers &&
      Object.keys(props).length != 0
    ) {
      setProjectTechList({
        ...state.OneProjectTechnicalTeamMembers,
      });
    } else {
      setProjectTechList({
        fourPartName: null,
        gender: null,
        idDocumentAttachment: null,
        cvDocumentAttachment: null,
        tE_TT_TypeOfWorkId: null,
        tE_TeamMembersPreviousExperiencePartnershipsId:
          state.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
      });
    }
  }, [state.OneProjectTechnicalTeamMembers]);
  const shouldDisableFields = !(
    //[,]
    // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
    (
      state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      window.location.href.includes("manager") == false
    )
  );
  return (
    <>
      {!state.loadingOneProjectTechnicalTeamMembers ? (
        <>
          <div className="AddEdite">
            <InputAHSF
              fieldsName="ThreeSyllableName"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setProjectTechList({
                  ...ProjectTechList,
                  fourPartName: e.target.value,
                });
              }}
              defaultValue={state.OneProjectTechnicalTeamMembers?.fourPartName}
              showValidationMessage={
                state.ProjectTechnicalTeamMembersValidate
                  ? state.ProjectTechnicalTeamMembersValidate.includes(
                      "ThreeSyllableName"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="Gender"
              show={true}
              disabled={shouldDisableFields}
              KeyText={"KeyText"}
              KeyValue={"KeyValue"}
              arrayOoptionList={MaleOrFemale}
              dropdownType={"normal"}
              onChange={(e) => {
                setProjectTechList({
                  ...ProjectTechList,
                  gender: e.target.value,
                });
              }}
              defaultValue={ProjectTechList?.gender}
              showValidationMessage={
                state.ProjectTechnicalTeamMembersValidate
                  ? state.ProjectTechnicalTeamMembersValidate.includes("Gender")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <AllDropDownsAHSF
              fieldsName="TypeOfWork"
              show={true}
              disabled={shouldDisableFields}
              arrayOoptionList={state.DropDownTE_TT_TypeOfWork}
              KeyText={"typeOfWorkNameAr"}
              KeyValue={"tE_TT_TypeOfWorkId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setProjectTechList({
                  ...ProjectTechList,
                  tE_TT_TypeOfWorkId: parseInt(e.target.value),
                });
              }}
              defaultValue={ProjectTechList?.tE_TT_TypeOfWorkId}
              showValidationMessage={
                state.ProjectTechnicalTeamMembersValidate
                  ? state.ProjectTechnicalTeamMembersValidate.includes(
                      "TypeOfWork"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <div style={{ marginTop: "10px" }}>
              <label>
                مرفق وثيقة اثبات الشخصية
                <span className="star">*</span>
              </label>
              <div style={{ marginTop: "20px" }}>
                <AttachmentASFH
                  id={"IDDocumentAttachment"}
                  text={"انقر لتعديل المرفق"}
                  title={"إضافة مرفق"}
                  disabled={shouldDisableFields}
                  show={shouldDisableFields ? false : true}
                  clear={false}
                  AttachementType="IDDocumentAttachment"
                  singleFile={
                    state.OneProjectTechnicalTeamMembers?.idDocumentAttachment
                  }
                  readOnly={false}
                  onChange={(e) => {
                    setFileChange(fileChange + 1);
                    setIDDocumentAttachment(e.target.files[0]);
                    setProjectTechList({
                      ...ProjectTechList,
                      idDocumentAttachment: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ProjectTechnicalTeamMembersValidate
                      ? state.ProjectTechnicalTeamMembersValidate.includes(
                          "IDDocumentAttachment"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>
            </div>
            <div style={{ marginTop: "20px" }}>
              <label>
                السيرة الذاتية
                <span className="star">*</span>
              </label>
              <div style={{ marginTop: "10px" }}>
                <AttachmentASFH
                  id={"CVDocumentAttachment"}
                  text={"انقر لتعديل المرفق"}
                  title={"إضافة مرفق"}
                  disabled={shouldDisableFields}
                  show={shouldDisableFields ? false : true}
                  clear={false}
                  AttachementType="CVDocumentAttachment"
                  singleFile={
                    state.OneProjectTechnicalTeamMembers?.cvDocumentAttachment
                  }
                  readOnly={false}
                  onChange={(e) => {
                    setFileChange2(fileChange2 + 1);
                    setCVDocumentAttachment(e.target.files[0]);
                    setProjectTechList({
                      ...ProjectTechList,
                      cvDocumentAttachment: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ProjectTechnicalTeamMembersValidate
                      ? state.ProjectTechnicalTeamMembersValidate.includes(
                          "CVDocumentAttachment"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>
            </div>

            {/* <AttachmentASFH
              //السيرة الذاتية
              id={"hhhh"}
              text={"text"}
              title={"title"}
              disabled={false}
              show={true}
              clear={false}
              readOnly={false}
            /> */}

            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateProjectTech()
                        : AddProjectTech();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneProjectTechnicalTeamMembers} />
    </>
  );
};

export default AddEditProjectTech;
